'use strict';

var _toConsumableArray = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var escapeStringRegexp = require('escape-string-regexp');

var transliterate = require('@sindresorhus/transliterate');

var builtinOverridableReplacements = require('./overridable-replacements');

var decamelize = function decamelize(string) {
  return string // Separate capitalized words.
  .replace(/([A-Z]{2,})(\d+)/g, '$1 $2').replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2').replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  var escapedSeparator = escapeStringRegexp(separator);
  return string.replace(new RegExp("".concat(escapedSeparator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(escapedSeparator, "|").concat(escapedSeparator, "$"), 'g'), '');
};

var slugify = function slugify(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(typeof string, "`"));
  }

  options = _objectSpread({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: [],
    preserveLeadingUnderscore: false
  }, options);
  var shouldPrependUnderscore = options.preserveLeadingUnderscore && string.startsWith('_');
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements)));
  string = transliterate(string, {
    customReplacements: customReplacements
  });

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = /[^a-zA-Z\d]+/g;

  if (options.lowercase) {
    string = string.toLowerCase();
    patternSlug = /[^a-z\d]+/g;
  }

  string = string.replace(patternSlug, options.separator);
  string = string.replace(/\\/g, '');

  if (options.separator) {
    string = removeMootSeparators(string, options.separator);
  }

  if (shouldPrependUnderscore) {
    string = "_".concat(string);
  }

  return string;
};

var counter = function counter() {
  var occurrences = new Map();

  var countable = function countable(string, options) {
    string = slugify(string, options);

    if (!string) {
      return '';
    }

    var stringLower = string.toLowerCase();
    var numberless = occurrences.get(stringLower.replace(/(?:-\d+?)+?$/, '')) || 0;
    var counter = occurrences.get(stringLower);
    occurrences.set(stringLower, typeof counter === 'number' ? counter + 1 : 1);
    var newCounter = occurrences.get(stringLower) || 2;

    if (newCounter >= 2 || numberless > 2) {
      string = "".concat(string, "-").concat(newCounter);
    }

    return string;
  };

  countable.reset = function () {
    occurrences.clear();
  };

  return countable;
};

module.exports = slugify;
module.exports.counter = counter;